<script setup>
import { ref } from 'vue'
import axios from 'axios'

const name = ref(null)
const email = ref(null)
const phone = ref(null)
const company = ref(null)
const title = ref(null)

const contactId = ref(null)

async function addContact() {
    try {
        const { data } = await axios.post(route('utility.lead.store'), {
            name: name.value,
            email: email.value,
            phone: phone.value,
            company: company.value,
            title: title.value,
        })

        contactId.value = data

        name.value = null
        email.value = null
        phone.value = null
        company.value = null
        title.value = null
    } catch (error) {
    }
}
</script>

<template>
    <div>
        <div v-if="contactId !== null">
            <h5>{{ _mft('crm:addContact.created') }}</h5>
            <a :href="route('crm.leads.view', contactId)" class="mf-link">
                {{ _mft('crm:addContact.openContact') }}
            </a>
            <hr class="mt-5 mb-5">
        </div>

        <div>
            <input-text
                v-model:content="name"
                :label="_mft('crm:contact.fields.name')"
                :placeholder="_mft('crm:addContact.placeholder.name')"
                maxlength="255"
                :required="true"
            />
            <input-text
                v-model:content="email"
                :label="_mft('crm:contact.fields.email')"
                :placeholder="_mft('crm:addContact.placeholder.email')"
                maxlength="255"
                inputtype="email"
            />
            <input-text
                v-model:content="phone"
                :label="_mft('crm:contact.fields.phone')"
                :placeholder="_mft('crm:addContact.placeholder.phone')"
                maxlength="255"
            />
            <input-text
                v-model:content="company"
                :label="_mft('crm:company')"
                :placeholder="_mft('crm:addContact.placeholder.company')"
                maxlength="255"
            />
            <input-text
                v-model:content="title"
                :label="_mft('crm:contact.fields.title')"
                :placeholder="_mft('crm:addContact.placeholder.title')"
                maxlength="255"
            />
            <div class="flex justify-end mb-2 -mt-2">
                <button-secondary
                    size="sm"
                    @click="addContact"
                >
                    {{ _mft('crm:addContact') }}
                </button-secondary>
            </div>
        </div>
    </div>
</template>
